module.exports = __webpack_public_path__ + "static/img/zhaoshang01.f63a62aa.jpg";